









































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency";
import { useEmployeeContributionHistoryStore } from "@/employer/store/employeeContributionHistory";


@Component
export default class EmployeeContributionHistorySummary extends Vue {
  contributionHistoryStore = useEmployeeContributionHistoryStore();


  @Prop({required: true})
  employeeId: number;

  formatCurrency (val: number) {
    return formatCurrency(val);
  }

  mounted () {
    this.contributionHistoryStore.loadSummary(this.employeeId);
  }

  @Watch("employeeId")
  getSummary () {
    this.contributionHistoryStore.loadSummary(this.employeeId);
  }
}

